import {
  isDebtLikeItems,
  isReportedCash,
  isReportedDebt,
} from '../../services/textService';
import {
  REPORTED_DEBT_KEY,
  COMPOSITE_KEY_DELIMITER,
  DEBT_LIKE_ITEMS_KEY,
  REPORTED_CASH_KEY,
} from './constants';

export const trimIfString = (value) => {
  if (typeof value === 'string' || value instanceof String) {
    return value.trim();
  }
  return value;
};

export const constructCompositeKey = (prefix, headers, keyIndexes, suffix) => {
  const identifiers = keyIndexes.map((index) => trimIfString(headers[index]));
  return [trimIfString(prefix), ...identifiers, trimIfString(suffix)].join(
    COMPOSITE_KEY_DELIMITER
  );
};

export const deconstructAdjustmentKey = (
  key,
  delimiter = COMPOSITE_KEY_DELIMITER
) => {
  if (key) {
    const [
      documentCode,
      adjustmentNumber,
      shortDescription,
      adjustmentType,
      adjustmentCategory,
      trialBalanceAccount,
      timePeriod,
    ] = key.split(delimiter);

    return {
      documentCode,
      adjustmentNumber,
      shortDescription,
      adjustmentType,
      adjustmentCategory,
      trialBalanceAccount,
      timePeriod,
    };
  }
  return key;
};

export const reconstructKeyForDdl = (
  key,
  delimiter = COMPOSITE_KEY_DELIMITER
) => {
  const [
    documentCode,
    adjustmentNumber,
    shortDescription,
    adjustmentType,
    adjustmentCategory,
    trialBalanceAccount,
    timePeriod,
  ] = key.split(delimiter);

  let updatedAdjustmentType = adjustmentType;
  if (isReportedDebt(adjustmentType)) {
    updatedAdjustmentType = REPORTED_DEBT_KEY;
  }

  if (isReportedCash(adjustmentType)) {
    updatedAdjustmentType = REPORTED_CASH_KEY;
  }

  if (isDebtLikeItems(adjustmentType)) {
    updatedAdjustmentType = DEBT_LIKE_ITEMS_KEY;
  }

  const updatedKey = `${documentCode}${delimiter}${adjustmentNumber}${delimiter}${shortDescription}${delimiter}${updatedAdjustmentType}${delimiter}${adjustmentCategory}${delimiter}${trialBalanceAccount}${delimiter}${timePeriod}`;

  return updatedKey;
};

export const deconstructFactKey = (
  key,
  delimiter = COMPOSITE_KEY_DELIMITER
) => {
  if (key) {
    const [
      documentCode,
      uniqueAccountId,
      shortDescription,
      aggregator,
      ebitdaFlag,
      timePeriod,
    ] = key.split(delimiter);

    return {
      documentCode,
      uniqueAccountId,
      shortDescription,
      aggregator,
      ebitdaFlag,
      timePeriod,
    };
  }
  return key;
};
